import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import {
  ANSWERS_LIMIT_REACHED,
  WARFARE_SUBSCRIPTION,
} from '../../utils/questionConstants';
import { Desktop, Mobile } from '../Common/const';
import HelpButton from '../Common/HelpButton/HelpButton';
import RichText from '../Common/RichText/RichText';
import NotificationPopUp from '../Headers/NotificationPopUp';
import NotificationPopUpFree from '../Headers/NotificationPopUpFree';
import TutorialModal from '../PracticeExam/Modals/TutorialModal/TutorialModal';
import WarfareModal from '../PracticeExam/WarfareModal';
import SwitchToPaidModal from '../SwitchToPaid/SwitchToPaidModal';
import Breadcrums from './Breadcrums';
import StudySpeedSection from './components/StudySpeedSection';
import FurtherReading from './FurtherReading';
import QuestionCard from './QuestionCard';
import QuestionFavoritesButton from './QuestionFavoritesButton';
import QuestionFeedback from './QuestionFeedback';
import QuestionFeedbackButtons from './QuestionFeedbackButtons';
import QuestionRemaining from './QuestionRemaining';
import RateButtons from './RateButtons';
import ReCaptchaModal from './ReCaptchaModal/ReCaptchaModal';

class QuestionMain extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      update: false,
      pdfOpen: false,
      selectedThumb: null,
      isFavorite: this.props.question?.isFavorite ?? false,
      showFreePopUpModal: false,
      showCancelPopUp: false,
      showPlusOne: true,
      isOpenSwitchToPaid: false,
      hideSwitchToPaid: false,
      modalWarfare: false,
      clickFavorite: false,
      isTutorialModalOpen: false,
      isCaptchaModalOpen: false,
    };
  }

  selectThumb = (value) => {
    if (value) {
      this.setState({ selectedThumb: 'up' });
    } else {
      this.setState({ selectedThumb: 'down' });
    }
  };

  toggleFavorite = (value) => {
    this.setState({ isFavorite: value });
    this.props.favoriteQuestion(
      this.props.question.id,
      value,
      this.props.user.id,
    );
  };

  handleToggleTutorialModal = () => {
    this.setState({ isTutorialModalOpen: !this.state.isTutorialModalOpen });
  };

  getTutorialModalStatus = () => {
    const hasUserSeenModal = localStorage.getItem('tutorialModalStatus');

    return JSON.parse(hasUserSeenModal);
  };

  setTutorialModalDone = () => {
    localStorage.setItem('tutorialModalStatus', JSON.stringify(true));
  };

  componentDidMount() {
    if (this.props.isPreviewMode) {
      return;
    }

    if (window.screen.width < 768) {
      window.Intercom('update', {
        hide_default_launcher: true,
      });
    } else {
      window.Intercom('update', {
        hide_default_launcher: false,
      });
    }

    const hasShownTutorialModal = this.getTutorialModalStatus();

    if (!hasShownTutorialModal) {
      this.setState({ isTutorialModalOpen: true });
    }

    const hashLocation = window.location.hash;

    if (hashLocation.includes('studySubmittedQuestions')) {
      this.props.checkChapterInReview({
        method: 'submit',
      });
    } else if (hashLocation.includes('studyFavoriteQuestion')) {
      this.props.checkChapterInReview({
        method: 'favorite',
      });
    } else if (hashLocation.includes('studyMyFavoriteQuestion')) {
      this.props.checkChapterInReview({
        method: 'myFavorite',
      });
    } else if (hashLocation.includes('studyMySubmittedQuestion')) {
      this.props.checkChapterInReview({
        method: 'mySubmit',
      });
    }
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevProp.question && this.props.question) {
      if (prevProp.question.id !== this.props.question.id) {
        this.setState({
          isFavorite: this.props.question.isFavorite,
        });

        if (
          this.props.listFavoriteQuestions?.length &&
          this.props.loadingFavoriteQuestion
        ) {
          this.setState({
            isFavorite: this.props.listFavoriteQuestions.some(
              (q) =>
                q.id === this.props.question.id ||
                q.question === this.props.question.id,
            ),
          });
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.getCountQuestions === 1 && !this.props.getRecaptchaTime) {
      const dateToSet = Date.now();
      this.props.setRecaptchaTime(dateToSet);
    }
    if (nextProps.getCountQuestions >= 20) {
      const dateNow = Date.now();
      const needRecaptcha =
        (dateNow - this.props.getRecaptchaTime) / 1000 <= 60;
      if (needRecaptcha) {
        this.setState({ isCaptchaModalOpen: true });
      }
    }
    if (
      this.props.answerResponse !== nextProps.answerResponse &&
      nextProps.answerResponse === WARFARE_SUBSCRIPTION &&
      nextProps.location?.pathname === '/app/question'
    ) {
      this.setState({ modalWarfare: true });
    }

    if (nextProps.setFavoriteMessage === 'error') {
      this.setState({
        isFavorite: false,
      });
    }
  }

  componentWillUnmount() {
    window.Intercom('update', {
      hide_default_launcher: false,
    });
    this.props.openPdfViewer(false);
    this.props.setCountQuestions(0);
    this.props.setRecaptchaTime(null);
    this.props.clearAnswerResponse();
  }

  // PDF VIEWER
  openPdfViewer = () => {
    const userSubscription = this.props.userSubscription;
    const isTrial = userSubscription?.status === 'trialing';
    const isCancelled = userSubscription?.isCancelled;
    const hasNoStatus = userSubscription && !userSubscription.status;
    if (isTrial || (isCancelled && hasNoStatus)) this.openSwitchToPaid();
    else this.props.openPdfViewer(true);
  };

  handleSendAnswer = (dif) => {
    if (this.state.selectedThumb) {
      this.props.handleSendAnswer(dif, this.state.selectedThumb);
      this.setState({ selectedThumb: null });
    } else {
      this.props.handleSendAnswer(dif, this.state.selectedThumb);
    }
  };

  isReferencePDF = (referencePDF, chapterPDF) => {
    if (chapterPDF !== null && chapterPDF !== '') {
      return chapterPDF;
    }
    return referencePDF;
  };

  getQuestionText = (qObj) =>
    qObj.flashMode ? qObj.flashQuestionText : qObj.text;

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text || '';
    result = result.replace(/<\/p><p>/g, '<br>');
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  openFreePopUp = (open) => {
    this.setState({ showFreePopUpModal: open });
  };

  openCancelPopUp = (open) => {
    this.setState({ showCancelPopUp: open });
  };

  openSwitchToPaid = () => {
    this.setState({ isOpenSwitchToPaid: true });
  };

  closeSwitchToPaid = (activated) => {
    if (this.props.onCloseTrialModal) {
      this.props.onCloseTrialModal();
    }
    if (activated)
      this.setState({ isOpenSwitchToPaid: false, hideSwitchToPaid: true });
    else history.goBack();
  };

  buttonSubscriptionType = () => {
    if (this.props.user?.transactionIosId) {
      return '/app/account-settings';
    }
    if (this.props.userSubscription && !this.props.user.transactionIosId) {
      return '/app/manage-subscription';
    }
  };

  closeReCaptchaModal = () => {
    this.props.setCountQuestions(0);
    this.props.setRecaptchaTime(null);
    this.setState({ isCaptchaModalOpen: false });
  };

  render() {
    const questionsLimitReached = this.state.hideSwitchToPaid
      ? false
      : this.props.answerResponse === ANSWERS_LIMIT_REACHED;
    let correctAnswer;
    const notes = this.props.question.notes;
    let pageForTitle = '';
    if (this.props.question.documentPage) {
      pageForTitle = ` - PAGE ${this.props.question.documentPage}`;
    }
    const reference =
      this.props.question.reference_name +
      this.props.question.reference_description +
      pageForTitle;

    if (this.props.question.flashMode === true) {
      correctAnswer = this.props.question.flashcardCorrectAnswer;
    } else {
      correctAnswer = this.props.question.correctAnswer;
    }

    const expression = window.navigator.userAgent
      .toLowerCase()
      .match(/msie | trident/);
    let is_IE = false;
    if (expression) {
      is_IE = expression.length > 0;
    }

    let dontShowPDF = true;
    if (this.props.userSubscription)
      dontShowPDF =
        this.props.userSubscription.status === 'trialing' ||
        (this.props.userSubscription.isCancelled &&
          !this.props.userSubscription.status);
    return (
      <div className="question-main-body">
        <Desktop>
          <div className="question-background">
            <div className="question-wrapper">
              <Breadcrums
                items={this.props.breadcrums}
                resetChapter={this.props.resetChapter}
              />
              {this.props.question?.reference_name &&
                this.props.question.chapter_name && (
                  <div className="row chapter-info">
                    <div className="col-lg-9 col-md-8 cl-sm-12 p-0">
                      {this.props.question.reference_name} /{' '}
                      {this.props.question.chapter_name}
                    </div>
                    {this.props.user?.userSetting?.studySpeed ? (
                      <StudySpeedSection
                        studySpeedSetting={
                          this.props.user.userSetting.studySpeed
                        }
                      />
                    ) : null}
                  </div>
                )}
              <div className="row">
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <h3>
                    <b>Q:</b>{' '}
                    <RichText
                      tag="span"
                      data-test="question-title"
                      className="questions-p"
                      html={this.renderSymbols(
                        this.getQuestionText(this.props.question),
                      )}
                    />
                    {/* HERE */}
                  </h3>
                  {this.props.question?.submittedByMe && (
                    <div className="submitted-by-me">
                      (Question submitted by me)
                    </div>
                  )}
                </div>
                <div className="col-lg-3 col-md-4  col-sm-12">
                  <QuestionRemaining
                    items={this.props.remaining}
                    counterType={this.props.question.counterType}
                    clicked={this.props.getClickedState}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="question-wrapper mt-dynamic"
            style={
              this.props.question && this.props.question.answers
                ? {}
                : { marginTop: '0rem' }
            }
          >
            {!this.props.isLoadingQuestions ? (
              <QuestionCard
                {...this.props.question}
                renderSymbols={this.renderSymbols}
                clicked={this.props.clicked}
                setClicked={this.props.setClicked}
                getClickedState={this.props.getClickedState}
                updateIsCorrect={this.props.updateIsCorrect}
                setPreviousAnswerClicked={this.props.setPreviousAnswerClicked}
                showPreviousAnswer={this.props.showPreviousAnswer}
                previousAnswerClicked={this.props.previousAnswerClicked}
                flashcard={this.props.flashcard}
                isLoadingQuestions={this.props.isLoadingQuestions}
                errorMessageGetQuestion={this.props.errorMessageGetQuestion}
              />
            ) : (
              <div className="loading-container">
                <div className="loading-text">Loading...</div>
              </div>
            )}

            <div className="row button-row mt-3">
              <div className="col-md-8 col-sm-12">
                {!this.props.renderViewPdfButton &&
                  !this.props.isLoadingQuestions &&
                  !this.props.errorMessageGetQuestion && (
                    <Button
                      className="btn-outline-secondary"
                      disabled={!!this.props.disablePrevious}
                      onClick={this.props.handlePreviousQuestion}
                    >
                      <i className="icon-chevron_left" />
                      Previous Question
                    </Button>
                  )}

                {this.props.renderViewPdfButton &&
                  window.screen.width >= 960 &&
                  !is_IE && (
                    <Button
                      color="secondary"
                      onClick={() => {
                        const url = this.isReferencePDF(
                          this.props.question.reference_pdf,
                          this.props.question.chapter_pdf,
                        );
                        this.props.getPdfByReference({ url });
                        this.openPdfViewer();
                      }}
                      disabled={
                        !this.props.question.reference_pdf &&
                        !this.props.question.chapter_pdf
                      }
                    >
                      View PDF reference
                    </Button>
                  )}
                {this.props.renderViewPdfButton &&
                  (window.screen.width < 960 || is_IE) && (
                    <Button
                      color="secondary"
                      onClick={() => {
                        const url = this.isReferencePDF(
                          this.props.question.reference_pdf,
                          this.props.question.chapter_pdf,
                        );
                        this.props.getPdfByReference({ url });
                        this.openPdfViewer();
                      }}
                      target="_blank"
                      disabled={
                        (!this.props.question.reference_pdf &&
                          !this.props.question.chapter_pdf) ||
                        dontShowPDF
                      }
                    >
                      View PDF reference
                    </Button>
                  )}
              </div>
              <div className="col-4 col-sm-12 col-lg-4">
                <RateButtons
                  addCountQuestions={this.props.addCountQuestions}
                  getCountQuestions={this.props.getCountQuestions}
                  clicked={this.props.clicked}
                  clickedHard={false}
                  clickedNormal={false}
                  clickedEasy={false}
                  buttonInfo={correctAnswer}
                  handleSendAnswer={this.handleSendAnswer}
                  question={this.props.question}
                  isCorrect={this.props.isCorrect}
                  user={this.props.user}
                  openFreePopUp={this.openFreePopUp}
                  openCancelPopUp={this.openCancelPopUp}
                  showPreviousAnswer={this.props.showPreviousAnswer}
                  flashcard={this.props.flashcard}
                  resetChapter={this.props.resetChapter}
                  items={this.props.remaining}
                  isLoadingQuestions={this.props.isLoadingQuestions}
                  errorMessageGetQuestion={this.props.errorMessageGetQuestion}
                  setFavoriteMessageAction={this.props.setFavoriteMessageAction}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-8">
                {this.props.clicked && !this.props.question?.submitterId ? (
                  <FurtherReading
                    disabled={dontShowPDF}
                    onDisabledClick={this.openSwitchToPaid}
                    reference={reference}
                    notes={notes}
                    openPdfViewer={this.openPdfViewer}
                    pdfUrl={this.isReferencePDF(
                      this.props.question.reference_pdf,
                      this.props.question.chapter_pdf,
                    )}
                    getPdfByReference={(url, chapter) =>
                      this.props.getPdfByReference({
                        url,
                        chapterId: chapter,
                      })
                    }
                  />
                ) : null}
              </div>
              <div className="col-4">
                <QuestionFeedback
                  clicked={this.props.clicked}
                  selectedThumb={this.state.selectedThumb}
                  isFavorite={this.state.isFavorite}
                  selectThumb={this.selectThumb}
                  toggleFavorite={this.toggleFavorite}
                  upVotes={this.props.question.positiveThumbs}
                  userPreviousVote={
                    this.props.question
                      ? this.props.question.userPreviousVote
                      : null
                  }
                  loadFavoriteQuestion={this.props.loadFavoriteQuestion}
                  setFavoriteMessage={this.props.setFavoriteMessage}
                  isLoadingQuestions={this.props.isLoadingQuestions}
                  errorMessageGetQuestion={this.props.errorMessageGetQuestion}
                  question={this.props.question}
                />
              </div>
            </div>
          </div>
        </Desktop>
        <Mobile>
          <div className="question-wrapper">
            <div className="question-background pt-3">
              <div className="col-sm-12">
                <QuestionRemaining
                  items={this.props.remaining}
                  counterType={this.props.question.counterType}
                  clicked={this.props.getClickedState}
                />
              </div>
              <div className="col-sm-12 questions-p">
                <RichText
                  tag="h3"
                  html={this.renderSymbols(
                    this.getQuestionText(this.props.question),
                  )}
                />
              </div>
            </div>
            {!this.props.isLoadingQuestions ? (
              <QuestionCard
                {...this.props.question}
                renderSymbols={this.renderSymbols}
                clicked={this.props.clicked}
                setClicked={this.props.setClicked}
                getClickedState={this.props.getClickedState}
                updateIsCorrect={this.props.updateIsCorrect}
                setPreviousAnswerClicked={this.props.setPreviousAnswerClicked}
                showPreviousAnswer={this.props.showPreviousAnswer}
                previousAnswerClicked={this.props.previousAnswerClicked}
                flashcard={this.props.flashcard}
              />
            ) : (
              <div className="loading-container">
                <div className="loading-text">Loading...</div>
              </div>
            )}

            <div className="mt-3 d-flex flex-row justify-content-between mobile-buttons">
              {!this.props.renderViewPdfButton ? (
                <div className="">
                  <Button
                    className="btn-outline-secondary rounded-lg"
                    disabled={!!this.props.disablePrevious}
                    onClick={this.props.handlePreviousQuestion}
                  >
                    <i className="icon-chevron_left" />
                    Previous
                  </Button>
                </div>
              ) : (
                <div className=" text-center">
                  <Button
                    color="secondary"
                    className="rounded-lg"
                    onClick={() =>
                      this.props.getPdfByReference({
                        url: this.props.question.chapter_pdf,
                        chapterId: this.props.question.chapter,
                      })
                    }
                    target="_blank"
                    disabled={
                      (!this.props.question.reference_pdf &&
                        !this.props.question.chapter_pdf) ||
                      dontShowPDF
                    }
                  >
                    VIEW PDF
                  </Button>
                </div>
              )}

              <div className="text-right feedback">
                <HelpButton question={this.props.question} />
              </div>
            </div>
            <div className="row ml-0 mr-0">
              <div className="col-sm-12 mt-5">
                <RateButtons
                  addCountQuestions={this.props.addCountQuestions}
                  getCountQuestions={this.props.getCountQuestions}
                  clicked={this.props.clicked}
                  clickedHard={false}
                  clickedNormal={false}
                  clickedEasy={false}
                  buttonInfo={correctAnswer}
                  handleSendAnswer={this.handleSendAnswer}
                  question={this.props.question}
                  isCorrect={this.props.isCorrect}
                  user={this.props.user}
                  openFreePopUp={this.openFreePopUp}
                  openCancelPopUp={this.openCancelPopUp}
                  showPreviousAnswer={this.props.showPreviousAnswer}
                  flashcard={this.props.flashcard}
                  resetChapter={this.props.resetChapter}
                  items={this.props.remaining}
                  setFavoriteMessageAction={this.props.setFavoriteMessageAction}
                />
              </div>
            </div>
            <div className="row ml-0 mr-0 mt-2">
              <div className="col-12">
                {this.props.clicked ? (
                  <div className="feedback mt-3 mb-3">
                    <QuestionFavoritesButton
                      isFavorite={this.state.isFavorite}
                      toggleFavorite={this.toggleFavorite}
                    />
                    <QuestionFeedbackButtons
                      clicked={this.props.clicked}
                      selectedThumb={this.state.selectedThumb}
                      selectThumb={this.selectThumb}
                    />
                    {this.props.setFavoriteMessage && (
                      <div className="mt-2 text-center">
                        {this.props.setFavoriteMessage === 'add' && (
                          <span className="message-success">
                            {' '}
                            Save question to my favorites{' '}
                          </span>
                        )}
                        {this.props.setFavoriteMessage === 'remove' && (
                          <span className="message-remove">
                            {' '}
                            Remove question from my favorites{' '}
                          </span>
                        )}
                        {this.props.setFavoriteMessage === 'error' && (
                          <span className="message-error">
                            {' '}
                            Error when trying to remove or add a question as a
                            favorite. Please try again later{' '}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                ) : null}
                {this.props.clicked && !this.props.question?.submitterId ? (
                  <FurtherReading
                    disabled={dontShowPDF}
                    onDisabledClick={this.openSwitchToPaid}
                    reference={reference}
                    notes={notes}
                    pdfUrl={this.isReferencePDF(
                      this.props.question.reference_pdf,
                      this.props.question.chapter_pdf,
                    )}
                    getPdfByReference={(url, chapter) =>
                      this.props.getPdfByReference({
                        url,
                        chapterId: chapter,
                      })
                    }
                  />
                ) : null}
              </div>
            </div>
          </div>
        </Mobile>
        <NotificationPopUpFree
          isOpen={this.state.showFreePopUpModal}
          openFreePopUp={this.openFreePopUp}
        />
        <NotificationPopUp
          isOpen={this.state.showCancelPopUp}
          openCancelPopUp={this.openCancelPopUp}
          buttonLink={this.buttonSubscriptionType()}
          user={this.props.user}
        />
        <SwitchToPaidModal
          user={this.props.user}
          userSubscription={this.props.userSubscription}
          isOpen={
            this.state.isOpenSwitchToPaid ||
            questionsLimitReached ||
            this.props.showTrialModal ||
            (this.props.cantStudy &&
              this.props.userSubscription?.status === 'trialing')
          }
          onCancel={(activated) => this.closeSwitchToPaid(activated)}
          activateSubscription={() => this.props.activateSubscription()}
          subscriptionActivationSucces={this.props.subscriptionActivationSucces}
          subscriptionActivationWaiting={
            this.props.subscriptionActivationWaiting
          }
          subscriptionActivationMessage={
            this.props.subscriptionActivationMessage
          }
        />
        {this.state.modalWarfare && (
          <WarfareModal
            open={this.state.modalWarfare}
            closeModal={() => history.push('/app/study')}
          />
        )}
        {this.state.isTutorialModalOpen && (
          <TutorialModal
            isOpen={this.state.isTutorialModalOpen}
            toggle={this.handleToggleTutorialModal}
            setTutorialModalDone={this.setTutorialModalDone}
          />
        )}

        {this.state.isCaptchaModalOpen && (
          <ReCaptchaModal
            isOpen={this.state.isCaptchaModalOpen}
            closeModal={this.closeReCaptchaModal}
          />
        )}
      </div>
    );
  }
}

export default QuestionMain;
